var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9603 2.66626C8.60029 2.66626 2.62695 8.63959 2.62695 15.9996C2.62695 23.3596 8.60029 29.3329 15.9603 29.3329C23.3203 29.3329 29.2936 23.3596 29.2936 15.9996C29.2936 8.63959 23.3336 2.66626 15.9603 2.66626ZM19.9603 18.9729L16.0936 21.1996C15.6136 21.4796 15.0803 21.6129 14.5603 21.6129C14.027 21.6129 13.507 21.4796 13.027 21.1996C12.067 20.6396 11.4936 19.6529 11.4936 18.5329V14.0663C11.4936 12.9596 12.067 11.9596 13.027 11.3996C13.987 10.8396 15.1336 10.8396 16.107 11.3996L19.9736 13.6263C20.9336 14.1863 21.507 15.1729 21.507 16.2929C21.507 17.4129 20.9336 18.4129 19.9603 18.9729Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play-circle.7163fda33e813ef1e1a8189125d30bc6.svg";
export { ForwardRef as ReactComponent };